import { reactive } from 'vue'

export const state = reactive({
  open: false,
  type: 'alert', // 'alert' | 'confirm'
  messageHtml: '',
  okText: 'OK',
  cancelText: 'キャンセル',
  _resolve: null,
})

function openBase({ type, message, okText, cancelText }) {
  state.type = type
  state.okText = okText ?? (type === 'confirm' ? 'OK' : 'OK')
  state.cancelText = cancelText ?? 'キャンセル'
  // 改行対応（XSSを避けるため、ここでは文字列の改行だけを <br> に）
  state.messageHtml = String(message).replace(/\n/g, '<br>')
  state.open = true

  return new Promise((resolve) => {
    state._resolve = resolve
  })
}

// alert相当（OKで解決）
export function alertDialog(message, options = {}) {
  return openBase({ type: 'alert', message, ...options }).then(() => true)
}

// confirm相当（OK=true / cancel=false）
export function confirmDialog(message, options = {}) {
  return openBase({ type: 'confirm', message, ...options })
}

export function resolveOk() {
  if (!state.open) return
  state.open = false
  state._resolve?.(true)
  state._resolve = null
}

export function resolveCancel() {
  if (!state.open) return
  state.open = false
  state._resolve?.(false)
  state._resolve = null
}
